import { observable } from "mobx";

export default class Role {
  @observable id: number;
  @observable principalId: string;
  @observable principalType: string;
  @observable roleId: number;

  constructor(data: JSON) {
    this.extend(data);
  }

  extend(data: JSON) {
    Object.assign(this, data);
  }
}



// WEBPACK FOOTER //
// ./src/stores/Role.js